export default __webpack_public_path__ + "static/optoppingen-desktop-f43deec4e583095f23073b292a343fd8.svg";